export default "__VITE_ASSET__CFnT6W7M__"